import { render, staticRenderFns } from "./charger-details.vue?vue&type=template&id=0adaf6fc"
import script from "./charger-details.vue?vue&type=script&lang=js"
export * from "./charger-details.vue?vue&type=script&lang=js"
import style0 from "./charger-details.vue?vue&type=style&index=0&id=0adaf6fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports